// extracted by mini-css-extract-plugin
var _1 = "TableStyles-module__header___tzDDb";
var _2 = "TableStyles-module__table___At8ya";
export { _1 as "header", _2 as "table" }
